import React, { useEffect } from "react";
import { LoginContextData } from "../Declarations";
import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

interface IFinalizeLoginProps {
    data: LoginContextData;
    onComplete: () => void;
}

export const FinalizeLogin = ({ data, onComplete }: IFinalizeLoginProps) => {
    const axiosAuth = createAxiosClient("Auth");

    const finalizeMutation = useMutation({
        mutationFn: async (): Promise<void> => {
            await axiosAuth.post(
                "/UILogin/FinalizeLogin",
                {
                    BrowserFingerPrint: data.BrowserFingerprint,
                    Password: data.Password,
                    UserAgent: navigator.userAgent,
                    UserID: data.UserID,
                    UserName: data.UserName,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    withCredentials: true, // allow backend to set cookies
                }
            );
        },
        onSuccess: onComplete,
    });

    useEffect(() => {
        finalizeMutation.mutate();
    }, []); // fire once on mount

    if (finalizeMutation.isPending) {
        return <p>Finalizing login...</p>;
    }

    if (finalizeMutation.isError) {
        return <p className="error">Final login step failed.</p>;
    }

    return null;
};
